import { render } from "./StatisticsDashboard.vue?vue&type=template&id=62ea7f0a&scoped=true&ts=true"
import script from "./StatisticsDashboard.vue?vue&type=script&lang=ts"
export * from "./StatisticsDashboard.vue?vue&type=script&lang=ts"

import "./StatisticsDashboard.vue?vue&type=style&index=0&id=62ea7f0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ea7f0a"]])

export default __exports__